<template>
    <div class="mt-12 flex flex-col">
        <div v-if="jobs.data.length || search" class="flex space-x-2 items-center mb-3">
            <div class="relative rounded-md shadow-sm">
                <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <svg class="h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 16l2.879-2.879m0 0a3 3 0 104.243-4.242 3 3 0 00-4.243 4.242zM21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                </div>
                <input autocomplete="off" type="text" name="query" id="query" v-model="query" class="focus:ring-indigo-500 focus:border-indigo-500 block w-full pl-10 sm:text-sm border-gray-300 rounded-md" placeholder="Search by Job title">
            </div>
            <div>
            <inertia-link preserve-state preserve-scroll href="/" as="button" type="button" :data="{ search: query }" class="inline-flex items-center px-3 py-3 border border-gray-300 shadow-sm text-sm leading-4 font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                Search
            </inertia-link>
            </div>
        </div>
        <div class="-my-2 sm:-mx-6 lg:-mx-8">
            <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                <div class="shadow border-b border-gray-200 sm:rounded-lg">
                    <table class="min-w-full divide-y divide-gray-200">
                        <thead>
                        <tr>
                            <th class="sm:rounded-tl-lg px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                                Company
                            </th>
                            <th class="px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                                Title
                            </th>
                            <th class="px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                                Status
                            </th>
                            <th class="px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                                Post date
                            </th>
                            <th class="sm:rounded-tr-lg px-6 py-3 border-b border-gray-200 bg-gray-50"></th>
                        </tr>
                        </thead>
                        <tbody class="bg-white">
                        <tr v-for="job in jobs.data">
                            <td class="px-6 py-4 whitespace-nowrap border-b border-gray-200">
                                <div class="flex items-center">
                                    <div class="flex-shrink-0 h-10 w-10">
                                        <img class="h-10 w-10 rounded-full"
                                             :src="job.company.logoAbsolute"
                                             alt=""/>
                                    </div>
                                    <div class="ml-4">
                                        <div class="text-sm leading-5 font-medium text-gray-900">{{
                                            job.company.name }}
                                        </div>
                                        <div class="text-sm leading-5 text-gray-500">{{ job.company.email }}
                                        </div>
                                    </div>
                                </div>
                            </td>
                            <td class="px-6 py-4 whitespace-normal border-b border-gray-200">
                                <div class="text-sm leading-5 text-gray-900">
                                    <inertia-link :href="route('publisher.jobs.show', [job.display_id])" class="hover:underline">
                                        {{ job.title }}
                                    </inertia-link>
                                </div>
                            </td>
                            <td class="px-6 py-4 whitespace-nowrap border-b border-gray-200">
                                <span
                                    class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full"
                                    :class="styleStatus(job.status)">{{ job.status }}</span>
                            </td>
                            <td class="px-6 py-4 whitespace-nowrap border-b border-gray-200">
                                <div class="text-sm leading-5 text-gray-900">{{ job.created_at | moment("dddd, MMMM Do YYYY") }}
                                </div>
                            </td>
                            <td class="px-6 py-4 whitespace-nowrap text-right border-b border-gray-200 text-sm leading-5 font-medium">
                                <IndexMenu :job="job"></IndexMenu>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <pagination :links="jobs.links"/>
    </div>
</template>

<script>
    import Pagination from '@/Jobroll/Pagination'
    import IndexMenu from "@/Jobroll/IndexMenu";

    export default {
        name: "JobIndex",
        components: {
            Pagination,
            IndexMenu
        },
        props: {
            jobs: Object,
            search: String
        },
        data() {
            return {
                query: this.search || null
            }
        },
        methods: {
            styleStatus(status) {
                switch (status) {
                    case 'published':
                        return 'bg-green-100 text-green-800';
                    case 'confirmed':
                        return 'bg-orange-100 text-orange-800';
                    case 'unconfirmed':
                        return 'bg-red-100 text-red-800';
                }
            }
        }
    }
</script>
